import HeaderlessLayout from "./HeaderlessLayout";

export default HeaderlessLayout;
